import React from 'react';
import ReactOdometer from 'react-odometerjs';

export const OdometerTags = ({odometerNumber}: {odometerNumber: number}) => {
    return <div className="odometer-container">
        <ReactOdometer value={odometerNumber} format={'(,ddd)'} duration={100}/>
    </div>
}